import React from 'react';
import { motion } from 'framer-motion';
import { Activity, Layers, Heart, TrendingDown, AlertTriangle, Radar, Cpu, Eye } from 'lucide-react';
const signals = [{
  icon: <Activity className="w-6 h-6" data-id="element-238" />,
  title: 'Cambios invisibles en el rendimiento',
  color: 'text-brand-blue',
  bg: 'bg-brand-blue/10',
  border: 'border-brand-blue/20'
}, {
  icon: <Layers className="w-6 h-6" data-id="element-239" />,
  title: 'Desequilibrios tácticos',
  color: 'text-brand-green',
  bg: 'bg-brand-green/10',
  border: 'border-brand-green/20'
}, {
  icon: <Heart className="w-6 h-6" data-id="element-240" />,
  title: 'Patrones de fatiga física',
  color: 'text-brand-gold',
  bg: 'bg-brand-gold/10',
  border: 'border-brand-gold/20'
}, {
  icon: <TrendingDown className="w-6 h-6" data-id="element-241" />,
  title: 'Ciclos de presión histórica',
  color: 'text-brand-blue',
  bg: 'bg-brand-blue/10',
  border: 'border-brand-blue/20'
}, {
  icon: <AlertTriangle className="w-6 h-6" data-id="element-242" />,
  title: 'Señales de inestabilidad en la plantilla',
  color: 'text-brand-green',
  bg: 'bg-brand-green/10',
  border: 'border-brand-green/20'
}, {
  icon: <Radar className="w-6 h-6" data-id="element-243" />,
  title: 'Microtendencias de momentum',
  color: 'text-brand-gold',
  bg: 'bg-brand-gold/10',
  border: 'border-brand-gold/20'
}, {
  icon: <Cpu className="w-6 h-6" data-id="element-244" />,
  title: 'Modelado probabilístico en vivo',
  color: 'text-brand-blue',
  bg: 'bg-brand-blue/10',
  border: 'border-brand-blue/20'
}, {
  icon: <Eye className="w-6 h-6" data-id="element-245" />,
  title: 'Lectura estructural del juego',
  color: 'text-brand-green',
  bg: 'bg-brand-green/10',
  border: 'border-brand-green/20'
}];
// Duplicate the array for seamless infinite loop
const loopedSignals = [...signals, ...signals];
export function SignalsCarousel() {
  return <section className="py-12 md:py-16 px-0 relative overflow-hidden" data-id="element-246">
      <div className="max-w-3xl mx-auto px-4 text-center mb-10" data-id="element-247">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-248">
          <div className="text-xs font-mono uppercase tracking-[0.3em] text-brand-blue mb-4" data-id="element-249">
            // SEÑALES NO OBVIAS
          </div>
          <h2 className="text-2xl md:text-4xl font-display font-bold leading-tight mb-4" data-id="element-250">
            Nada de esto es obvio.
            <br data-id="element-251" />
            <span className="text-brand-green" data-id="element-252">Todo esto es decisivo.</span>
          </h2>
        </motion.div>
      </div>

      {/* Carousel */}
      <div className="relative w-full" data-id="element-253">
        {/* Edge fades */}
        <div className="absolute left-0 top-0 bottom-0 w-24 md:w-48 bg-gradient-to-r from-brand-bg to-transparent z-10 pointer-events-none" data-id="element-254" />
        <div className="absolute right-0 top-0 bottom-0 w-24 md:w-48 bg-gradient-to-l from-brand-bg to-transparent z-10 pointer-events-none" data-id="element-255" />

        <div className="flex gap-4 animate-scroll-x w-max" data-id="element-256">
          {loopedSignals.map((signal, i) => <div key={i} className={`glass-card rounded-2xl p-6 w-[280px] md:w-[320px] shrink-0 ${signal.border}`} data-id="element-257">
              <div className={`w-12 h-12 rounded-xl ${signal.bg} ${signal.color} flex items-center justify-center mb-4 border ${signal.border}`} data-id="element-258">
                {signal.icon}
              </div>
              <p className="text-base md:text-lg font-display font-semibold text-white leading-snug" data-id="element-259">
                {signal.title}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}